import { getCardPropsMarkets, getCardPropsEventWithMbn, showGameStateForEvent, getSportConfig } from "../../../helpers";
export const getFixtureCardProps = (state, event, cms, dict) => {
    const sport = getSportConfig(event, state.isMiniEventCard, state.getCardConfiguration(event.sportId));
    const markets = getCardPropsMarkets(event, state.displayMarkets(event.id), sport);
    const ev = getCardPropsEventWithMbn(event, markets);
    return {
        event: ev,
        markets,
        isDesktop: state.deviceDetect.isDesktop,
        sport,
        handlers: {
            eventCard: state.openGameTranspiler.bind(state, event),
            betButton: state.addToSlipTranspiler.bind(state),
            favorites: state.manageFavorites.bind(state, event),
            liveStream: state.openLiveStream.bind(state, event.id),
            statistics: state.openStatTranspiler.bind(state, event.statisticsEventId)
        },
        isFavoritesEnabled: state.provider.isFavoritesEnabled,
        showMLTeamName: cms.ShowTeamNameML,
        showHeadingNames: !state.isMiniEventCard && state.shouldHideSubheadings,
        dict,
        showLeagueInEventCard: state.showLeagueInEventCard,
        hideLowOdds: cms.HideLowOdds,
        hideGameState: showGameStateForEvent(state.options.dataProvider.disableGameStateForSportIds, event.sportId),
        showOddBtns: state.showOddBtns
    };
};
//# sourceMappingURL=getFixtureCardProps.js.map